var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 0.0) scale(0.75)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3215"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "star 3",
    rx: 0,
    width: 31,
    height: 31,
    transform: "translate(0.500000 0.500000)",
    fill: "white",
    fillOpacity: 0
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "star 3",
    rx: 0,
    width: 31,
    height: 31,
    transform: "translate(0.500000 0.500000)",
    fill: "#fff",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.89 12.16C29.77 11.78 29.55 11.45 29.24 11.21C28.93 10.96 28.56 10.82 28.17 10.78L20.74 10.14L17.84 3.22C17.68 2.86 17.43 2.55 17.1 2.33C16.77 2.11 16.39 2 15.99 2C15.6 2 15.22 2.11 14.89 2.33C14.56 2.55 14.31 2.86 14.15 3.22L11.25 10.14L3.82 10.79C3.43 10.82 3.05 10.97 2.75 11.21C2.44 11.46 2.21 11.79 2.09 12.16C1.96 12.54 1.96 12.94 2.06 13.32C2.17 13.7 2.38 14.04 2.68 14.29L8.32 19.22L6.63 26.54C6.54 26.92 6.57 27.32 6.7 27.69C6.84 28.06 7.08 28.38 7.4 28.61C7.72 28.84 8.1 28.97 8.49 28.99C8.89 29.01 9.27 28.91 9.61 28.71L15.99 24.83L22.37 28.71C22.71 28.91 23.1 29.01 23.49 28.99C23.89 28.97 24.27 28.84 24.58 28.61C24.9 28.38 25.14 28.06 25.28 27.69C25.42 27.32 25.44 26.92 25.36 26.54L23.67 19.21L29.3 14.29C29.6 14.03 29.82 13.69 29.92 13.31C30.03 12.93 30.02 12.53 29.89 12.16ZM27.99 12.78L22.36 17.7C22.08 17.94 21.88 18.25 21.76 18.59C21.65 18.94 21.64 19.31 21.72 19.66L23.41 27L17.03 23.12C16.72 22.93 16.36 22.83 16 22.83C15.63 22.83 15.27 22.93 14.96 23.12L8.59 27L10.27 19.67C10.35 19.32 10.34 18.95 10.23 18.6C10.11 18.25 9.91 17.95 9.63 17.71L3.99 12.79C3.99 12.79 3.99 12.78 3.99 12.78L11.42 12.13C11.79 12.1 12.13 11.97 12.43 11.76C12.72 11.54 12.95 11.25 13.09 10.92L15.99 4.01L18.89 10.92C19.04 11.25 19.27 11.54 19.56 11.76C19.85 11.97 20.2 12.1 20.56 12.13L27.99 12.78C27.99 12.78 27.99 12.79 27.99 12.79L27.99 12.78Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b4663986b0227d58dcdc9440304d85c8.svg";
export { ForwardRef as ReactComponent };